import { useEffect, useRef } from "react";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

export interface ChannelUserInfo {
  id: string;
  name: string;
  [key: string]: any;
}

export const useChannelTalk = (
  userInfo?: ChannelUserInfo | null,
  enabled: boolean = true
) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (enabled && userInfo && !isInitialized.current) {
      ChannelService.loadScript();

      const bootOption: any = {
        pluginKey: "b42e529e-1eb4-413c-a55e-f2d671c76585",
        memberId: userInfo.id,
        profile: {
          name: userInfo.name,
        },
        hideChannelButtonOnBoot: true,
      };

      ChannelService.boot(bootOption);
      isInitialized.current = true;
    }

    return () => {
      if (isInitialized.current) {
        ChannelService.shutdown();
        isInitialized.current = false;
      }
    };
  }, [userInfo, enabled]);

  const openChat = () => {
    ChannelService.showMessenger();
  };

  return { openChat };
};
